export const useFirstMonthPriceCoupon = (data) => {
  let firstMonth = 0;
  let hasFirstMonth = true;
  const price = data.price;

  if (!data.discount) hasFirstMonth = false;

  firstMonth = calculatePriceWithCoupon(
    data?.discount_type,
    data?.discount,
    price,
  );

  return { data, firstMonth, hasFirstMonth };
};

const calculatePriceWithCoupon = (
  type: string,
  discount: number,
  price: number,
) => {
  if (!type || !discount || !price) return 0;
  const calculationFixedValue = price - discount;

  switch (type) {
    case 'fixed_value':
      return calculationFixedValue > 0 ? calculationFixedValue : 0;
    case 'percent':
      return price * ((100 - discount) / 100);
    default:
      return price;
  }
};
